angular
	.module 'App.Repository'
	.factory 'JournalEventRepository', [
		'BaseRepository',
		(BaseRepository) ->
			class JournalEventRepository extends BaseRepository
				@resource = '/journal_events'
				@isRestricted = true

			return new JournalEventRepository()
		]
